import { apiService } from './api'
import { Tag, TagFormData } from '../types'

export class TagService {
  async getTags(): Promise<Tag[]> {
    const response = await apiService.get<Tag[]>('/tags')
    return response
  }

  async getTag(id: number): Promise<Tag> {
    const response = await apiService.get<Tag>(`/tags/${id}`)
    return response
  }

  async createTag(data: TagFormData): Promise<Tag> {
    const response = await apiService.post<Tag>('/tags', data)
    return response
  }

  async updateTag(id: number, data: Partial<TagFormData>): Promise<Tag> {
    const response = await apiService.put<Tag>(`/tags/${id}`, data)
    return response
  }

  async deleteTag(id: number): Promise<void> {
    return apiService.delete<void>(`/tags/${id}`)
  }

  async searchTags(query: string): Promise<Tag[]> {
    const response = await apiService.get<Tag[]>('/tags/search', { q: query })
    return response
  }

  async getPopularTags(limit = 10): Promise<Tag[]> {
    const response = await apiService.get<Tag[]>('/tags/popular', { limit })
    return response
  }

  async bulkCreateTags(names: string[]): Promise<Tag[]> {
    const response = await apiService.post<Tag[]>('/tags/bulk', { names })
    return response
  }
}

export const tagService = new TagService()